import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

const antIcon = <LoadingOutlined style={{ fontSize: 36 }} spin />

export default function GraphLoading() {
  return (
    <div className="flex justify-center items-center h-[300px]">
      <Spin className="mt-4 mb-14" indicator={antIcon} />
    </div>
  )
}
